import languageService from '../../../services/LanguageService'

export const getVersionTagById = (versionTagId: string) => {
  return languageService.getVersionTags().filter((tag) => tag.id === versionTagId)
}
